<app-breadcrumb [master]="'Terminale'" [parentName]="'Transakcje'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
    <app-terminals-imports-row-details-view [terminalsImportRow]="terminalsImportRow" (modifyClicked)=" loadReceivablesImportsRow()" ></app-terminals-imports-row-details-view >

  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [terminalsImportRow]="terminalsImportRow"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
